import React, { useState } from 'react';

const Twentysecondtheme = ({get_data}) => {
    const [cart, setCart] = useState([]);

    const addToCart = (item) => {
        setCart([...cart, item]);
        alert(`${item.service_name} added to cart!`);
    };

    return (
        <>
            <style>{`
        :root {
            /* Palette: Mint Fresh */
            --primary: #10b981;       /* Emerald 500 */
            --primary-dark: #047857;  /* Emerald 700 */
            --bg-light: #ecfdf5;      /* Emerald 50 */
            --text-dark: #065f46;     /* Emerald 900 */
            --white: #ffffff;
            --font-family: 'Quicksand', sans-serif;
            --radius: 25px;
        }

        body { font-family: var(--font-family); background-color: var(--white); color: var(--text-dark); margin: 0; }
        .container { max-width: 1200px; margin: 0 auto; padding: 0 20px; }
        
        .navbar { padding: 20px; background: var(--bg-light); border-radius: 0 0 20px 20px; display: flex; justify-content: space-between; align-items: center; }
        .brand { font-size: 1.5rem; font-weight: 700; color: var(--primary-dark); }
        .nav-links a { margin-left: 20px; color: var(--text-dark); text-decoration: none; font-weight: 600; }
        
        .hero { background: var(--bg-light); padding: 80px 40px; border-radius: 30px; margin: 30px auto; text-align: center; max-width: 900px; }
        .hero h1 { font-size: 3rem; color: var(--primary-dark); margin-bottom: 20px; }
        .btn { background: var(--primary); color: white; padding: 12px 25px; border-radius: 50px; font-weight: 700; border: none; cursor: pointer; transition: 0.2s; }
        .btn:hover { background: var(--primary-dark); transform: scale(1.05); }

        .section-title { text-align: center; font-size: 2.2rem; color: var(--primary-dark); margin: 60px 0 40px; }
        
        .grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 30px; }
        .card { background: var(--bg-light); padding: 30px; border-radius: var(--radius); text-align: center; transition: 0.3s; border: 2px solid transparent; }
        .card:hover { border-color: var(--primary); background: white; box-shadow: 0 10px 20px rgba(16, 185, 129, 0.1); }
        
        .icon { font-size: 2.5rem; margin-bottom: 15px; color: var(--primary); }
        .product-img { width: 100%; height: 200px; object-fit: cover; border-radius: 15px; margin-bottom: 15px; }

        .footer { background: var(--primary-dark); color: white; padding: 40px; margin-top: 80px; text-align: center; border-radius: 20px 20px 0 0; }
            `}</style>
            
            <link href="https://fonts.googleapis.com/css2?family=Quicksand:wght@400;600;700&display=swap" rel="stylesheet" />

            <div className="container">
                <nav className="navbar">
                    <div className="brand">{get_data.service_name}</div>
                    <div className="nav-links">
                        <a href="#">Home</a>
                        <a href="#services">Services</a>
                        <a href="#products">Store</a>
                    </div>
                </nav>
            </div>

            <div className="container">
                <header className="hero">
                    <h1>Fresh & Clean Solutions.</h1>
                    <p style={{fontSize: '1.1rem', marginBottom: '30px'}}>We bring a breath of fresh air to everything we do.</p>
                    <a href="#contact" className="btn">Get Started</a>
                </header>

                <h2 className="section-title" id="services">What We Do</h2>
                <div className="grid">
                     {get_data.categories && get_data.categories.map((item, index) => (
                        <div className="card" key={index}>
                             <div className="icon">
                                 {item.icon ? <img src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`} style={{width: '50px', height: '50px', borderRadius: '50%'}} alt=""/> : '☘'}
                             </div>
                             <h3>{item.name}</h3>
                             <p>{item.description}</p>
                        </div>
                     ))}
                </div>

                <h2 className="section-title" id="products">Fresh Picks</h2>
                <div className="grid">
                     {get_data.product_services && get_data.product_services.map((item, index) => (
                        <div className="card" key={index} style={{textAlign: 'left'}}>
                             <img src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} className="product-img" alt={item.service_name}/>
                             <h3>{item.service_name}</h3>
                             {item.price && <div style={{color: 'var(--primary)', fontWeight: 'bold', fontSize: '1.1rem', margin: '5px 0'}}>₹{item.price}</div>}
                             <button onClick={() => addToCart(item)} className="btn" style={{marginTop: '10px', width: '100%'}}>Add to Cart</button>
                        </div>
                     ))}
                </div>
            </div>

            <footer className="footer" id="contact">
                <h3>{get_data.service_name}</h3>
                <p style={{opacity: 0.8}}>{get_data.business_location_name}</p>
                <div style={{marginTop: '20px', fontSize: '0.9rem'}}>
                    &copy; {new Date().getFullYear()} All Rights Reserved.
                </div>
            </footer>
        </>
    );
};

export default Twentysecondtheme;
